<template>
  <div class="produto-cdlsaude-planos">
    <div class="content">
      <div class="row">
        <div class="col-6 p-4">
          <Titulo
            title="Troca de Acomodação"
            description="Confira todos os dados antes de enviar para a conferência."
          />
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-md-7 col-lg-9">
          <div class="troca-info d-flex align-items-center">
            <div class="troca-icon">
              <span class="material-icons text-muted">night_shelter </span>
            </div>
            <div class="troca-desc">
              TROCA DE {{ descAcomodacao }}<br />
              <strong
                >PARA
                {{
                  descAcomodacao === "APARTAMENTO"
                    ? "ENFERMARIA"
                    : "APARTAMENTO"
                }}</strong
              >
            </div>
          </div>
        </div>
        <div class="col-md-5 col-lg-3">
          <FormulateInput
            class="border rounded p-2 bg-white"
            label="Selecione a data de vigência"
            type="date"
            v-model="dataVigencia"
            name="Data de Vigência"
            placeholder="Data Vigência"
            :validation="`required|after:${dataValidation}`"
            :min="dataMinVigencia"
            @change="simularTroca()"
          />
        </div>
      </div>

      <div class="mt-4">
        <div
          class="bg-white rounded p-4 mb-2"
          v-for="(vida, index) in simulacaoVidas"
          :key="index"
        >
          <div class="row align-items-center">
            <div class="col-md-6">
              <div class="label">
                {{ vida.cpF_DEPENDENTE === "" ? "Titular" : "Dependente" }}
              </div>
              <div class="value">{{ vida.nome }}</div>
            </div>
            <div class="col-md-3 text-left text-md-right mt-3 mt-md-0">
              <div class="label">Valor mensal atual</div>
              <div class="value text-muted">
                {{ vida.acomodacaoAtual | currency }}
              </div>
            </div>
            <div class="col-md-3 text-left text-md-right mt-3 mt-md-0">
              <div class="label">Novo valor mensal</div>
              <div class="value text-primary">
                {{ vida.acomodacaoPretendida | currency }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="mt-4">Valor do mês proporcional a data de vigência:</p>
      <div class="price-total mt-3">
        Total <strong class="text-primary">{{ total | currency }}</strong>
      </div>

      <!-- <div class="row">
        {{ simulacaoVidas }}
      </div>
      <div>
        <strong class="font-weight-bold h4 text-primary">
          {{ total | currency }}
        </strong>
      </div> -->
      <p v-if="carencia" class="alert alert-warning w-100 mt-5">
        Você está em período de carência, enquanto isso não é permitido efetuar
        a troca da acomodação.
      </p>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            :link="`/produto/cdl-saude-plano/alterarPlano/${vidaSel[0].cpF_TITULAR}`"
            name-class="btn btn-outline-secondary btn-lg btn-block"
          >
            Voltar
          </Botao>
        </div>
        <div class="col-md-5 col-lg-4">
          <Botao
            title="Próximo"
            @click="salvarTroca"
            name-class="btn btn-cta btn-lg btn-block font-weight-bold"
            v-if="!carencia"
          >
            CONFIRMAR TROCA
          </Botao>
        </div>
      </div>
      <div class="py-5"></div>
    </div>
  </div>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
// import ListaPlanos from '@/components/planos/ListaPlanos'
import Botao from "@/components/botoes/Botao";
// import Loading from '../../../components/Loading.vue'
export default {
  name: "Trocaracaomodacao",
  components: {
    Titulo,
    // ListaPlanos,
    Botao,
  },
  data() {
    return {
      produto: {
        nome: "CDL Saúde",
        id: "CDL Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Troca de Acomodação",
          id: "troca_acomodacao",
        },
      ],
      listaVidas: [],
      vidaSel: [
        {
          cpF_TITULAR: null,
        },
      ],
      simulacaoVidas: [],
      acomodacao: {
        "001": "002",
        "002": "001",
      },
      dataVigencia: null,
      dataMinVigencia: null,
      dataValidation: null,
      descAcomodacao: "",
      total: 0,
      carencia: false,
    };
  },
  methods: {
    montarDados() {
      sessionStorage.removeItem("trocaAcomodacao");
      this.listaVidas = JSON.parse(sessionStorage.getItem("alterPlano"));
      this.vidaSel = this.listaVidas.filter(
        (el) => el.codvida == this.urlParams.codVida
      );

      this.descAcomodacao = this.vidaSel[0].acomodacao;

      const date = new Date();
      date.setDate(date.getDate() + 8);

      this.dataMinVigencia =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      date.setDate(date.getDate() - 1);
      this.dataValidation =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      this.dataVigencia = this.dataMinVigencia;
      this.simularTroca();
    },
    simularTroca() {
      this.$http
        .post("/api/GestaoSaude/SimularTrocaAcomodacao", {
          codVida: this.urlParams.codVida,
          codTipoAssist: this.acomodacao[this.vidaSel[0].codtipoassistencia],
          dataVigencia: this.dataVigencia,
        })
        .then((response) => {
          const simulacaoVidas = response.data.vidas;
          this.total = response.data.total;

          simulacaoVidas.forEach((vida, i) => {
            const dadosAdd = this.listaVidas.filter(
              (el) => el.codvida === vida.codVida
            );
            this.simulacaoVidas[i] = { ...dadosAdd[0], ...vida };
          });

          this.carencia = response.data.carencia;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    salvarTroca() {
      const dadosPagamento = {
        trocaAcomodacao: {
          codVida: this.urlParams.codVida,
          codTipoAssist: this.acomodacao[this.vidaSel[0].codtipoassistencia],
          dataVigencia: this.dataVigencia,
        },
        listaVidas: this.simulacaoVidas,
        total: this.total,
      };

      sessionStorage.setItem("trocaAcomodacao", JSON.stringify(dadosPagamento));
      this.$router.push({ name: "pagamentoacomodacao" });
    },
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  mounted() {
    this.montarDados();
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";
.produto-cdlsaude-planos /deep/ {
  .troca-info {
    font-size: 18px;
    line-height: 1.2;
    .material-icons {
      font-size: 52px;
    }
    .troca-desc {
      padding-left: 5px;
      color: #6c757d;
      strong {
        color: $secondary;
        font-weight: 700;
      }
    }
  }
  .label {
    font-weight: 300;
    font-size: 14px;
    margin-bottom: 6px;
  }
  .value {
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    color: #000;
    line-height: 1.4;
  }
  .price-total {
    font-weight: 700;
    font-size: 22px;
  }
  @import "@/assets/scss/_vue-formulate.scss";
}
</style>
